module.exports = __webpack_public_path__ + "img/environment-banner.815cf532.png";